import { Component } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import Swal from 'sweetalert2';
import { ReportesMadrService } from './services/reportes-madr.service';
import { TipoReporteMadr } from './interfaces/tipo-reporte-madr.interface';

@Component({
    selector: 'app-carga-reportes-madr',
    templateUrl: './carga-reportes-madr.component.html',
    styleUrls: ['./carga-reportes-madr.component.css'],
})
export class CargaReportesMadrComponent {
    anioSeleccionado: number | null = null;
    anioTemporal: number | null = null;
    mostrarModalAnio = false;
    reportes: TipoReporteMadr[] = [];
    selectedFile: File | undefined;
    reporteSeleccionado: TipoReporteMadr | null = null;
    reporteYaTieneArchivo = false;
    anioActual = new Date().getFullYear();
    anios: number[] = Array.from(
        { length: this.anioActual - 2025 + 1 },
        (_, index) => 2025 + index
    );

    constructor(
        private modalService: NgbModal,
        private translate: TranslateService,
        private reportesMadrService: ReportesMadrService
    ) {
        this.translate.setDefaultLang('es');
        this.translate.use('es');
    }

    ngOnInit(): void {
        this.obtenerTiposReporte();
    }

    obtenerTiposReporte(): void {
        this.reportesMadrService.obtenerTiposReporte().subscribe({
            next: (response) => {
                this.reportes = response.map((reporte) => ({
                    ...reporte,
                    archivo: null,
                }));
            },
            error: (error) => {
                console.error(
                    'Error obteniendo los tipos de reporte MADR:',
                    error
                );
            },
        });
    }

    seleccionarArchivo(event: Event, reporteId: number): void {
        const input = event.target as HTMLInputElement;

        if (!input.files || input.files.length === 0) {
            return;
        }

        const archivo = input.files[0];

        const reporte = this.reportes.find((item) => item.id === reporteId);

        if (reporte) {
            reporte.archivo = archivo;
        }
    }

    abrirModalAnio(): void {
        this.anioTemporal = this.anioSeleccionado;
        this.mostrarModalAnio = true;
    }

    cerrarModalAnio(): void {
        this.mostrarModalAnio = false;
    }

    continuarAnio(): void {
        if (!this.anioTemporal) {
            return;
        }

        this.anioSeleccionado = this.anioTemporal;
        this.cerrarModalAnio();
    }

    async openUploadModal(content: any, reporte: any) {
        this.selectedFile = undefined;
        this.reporteSeleccionado = reporte;
        this.reporteYaTieneArchivo = !!reporte.archivo;
        this.modalService.open(content);
    }

    closeUploadModal() {
        this.modalService.dismissAll();
    }

    onFileSelected(event: Event) {
        const input = event.target as HTMLInputElement;
        if (input.files && input.files.length > 0) {
            const file = input.files[0];
            const allowedExtensions = /(\.xlsx)$/i;

            if (!allowedExtensions.exec(file.name)) {
                Swal.fire(
                    'Error con el archivo',
                    'Por favor, selecciona un archivo con extensión .xlsx',
                    'warning'
                );
                input.value = '';
                return;
            }

            if (file.size === 0) {
                Swal.fire(
                    'Archivo vacío',
                    'El archivo seleccionado está vacío o pesa 0 KB.',
                    'warning'
                );

                input.value = '';
                this.selectedFile = undefined;
                return;
            }

            this.selectedFile = file;
        }
    }

    getFileSize(size: number): string {
        const fileSizeInKB = size / 1024;
        return fileSizeInKB.toFixed(2) + ' KB';
    }

    saveReportes(): void {
        if (!this.anioSeleccionado) {
            Swal.fire(
                'Año requerido',
                'Por favor, selecciona un año antes de guardar los reportes.',
                'warning'
            );

            return;
        }

        const reportesSeleccionados = this.reportes.filter(
            (reporte) => reporte.archivo
        );

        if (reportesSeleccionados.length === 0) {
            Swal.fire(
                'Reportes requeridos',
                'Debes seleccionar al menos un reporte para cargar.',
                'warning'
            );

            return;
        }

        const formData = new FormData();

        formData.append('anio', this.anioSeleccionado.toString());

        reportesSeleccionados.forEach((reporte) => {
            formData.append('reporteIds', reporte.id.toString());

            formData.append(
                'archivos',
                reporte.archivo!,
                reporte.archivo!.name
            );
        });

        this.reportesMadrService.cargarReportes(formData).subscribe({
            next: (response) => {
                Swal.fire(
                    '¡Éxito!',
                    'Los reportes fueron cargados correctamente.',
                    'success'
                );

                this.reportes.forEach((reporte) => {
                    reporte.archivo = null;
                });
            },

            error: (error) => {
                console.error('Error cargando reportes:', error);

                Swal.fire(
                    'Error',
                    error?.error?.message ||
                        'Ocurrió un error al cargar los reportes.',
                    'error'
                );
            },
        });
    }

    saveUpload() {
        if (!this.selectedFile || !this.reporteSeleccionado) {
            return;
        }

        const reporte = this.reportes.find(
            (item) => item.id === this.reporteSeleccionado.id
        );

        if (reporte) {
            reporte.archivo = this.selectedFile;
        }

        this.closeUploadModal();
    }

    get cantidadReportesSeleccionados(): number {
        return this.reportes.filter((reporte) => reporte.archivo).length;
    }
}
